import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Box,
} from '@mui/material';
import { QRCodeSVG } from 'qrcode.react';
import { globalConfig } from '../configuration/config';
import { useTranslation } from "react-i18next";

const CompanyLink = () => {
  const [open, setOpen] = useState(false);
  const [link, setLink] = useState('');
  const [companyId, setCompanyId] = useState(null);
  const [tooltipState, setTooltipState] = useState('copy'); // 'copy' | 'copied'
  const { t } = useTranslation();

  useEffect(() => {
    const updateLink = () => {
      const company = JSON.parse(localStorage.getItem('company'));
      if (company?.id) {
        setCompanyId(company.id);
        setLink(`${globalConfig.config.common.chat}/companies?id=${company.id}`);
      }
    };

    updateLink();

    const observer = setInterval(updateLink, 1000);
    const handleStorageChange = (event) => {
      if (event.key === 'company') updateLink();
    };
    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      clearInterval(observer);
    };
  }, []);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const copyLink = async () => {
    try {
      if (navigator.clipboard) {
        await navigator.clipboard.writeText(link);
        setTooltipState('copied');
      }
    } catch (err) {
      console.error('Clipboard copy error:', err);
    }
  };

  const resetTooltip = () => setTooltipState('copy');

  return (
    <div>
      <div className="bm-item menu-item" onClick={handleOpen}>
        { t("menu.companyLink") }
      </div>

      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth={false}
        fullWidth
        sx={{ '& .MuiDialog-paper': { maxWidth: '505px' } }}>
        <Box display="flex" justifyContent="space-between" alignItems="center" p={2} mb={-2}>
          <div className="infoList--title">{ t("menu.companyLink") }</div>
        </Box>

        <DialogContent sx={{ p: 0 }}>
          <div className="qr-view qr-view--display qr-view--display-view">
            <QRCodeSVG value={link} size={128} />
            <input id="copyLink" disabled value={link} style={{ marginTop: 10 }} />
            <div className="tooltip">
              <i onClick={copyLink} onMouseOut={resetTooltip}>
                <span className="tooltiptext" id="TooltipText">
                  { t(`companyLink.tooltip.${tooltipState}`) }
                </span>
              </i>
            </div>
          </div>
        </DialogContent>

        <DialogActions>
          <button type="button" className="" onClick={handleClose}>
            { t('companyLink.buttons.close') }
          </button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default CompanyLink;
